import './style.scss';
import './blocks/Layout/ColorCycleContainer/front';
import './blocks/Layout/ImageCycle/front';

let domReady = window?.wp?.domReady;

// Fallback if wp.domReady is not available
if (!domReady) {
  console.warn('wp.domReady not found, using fallback.');
  domReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };
}

// Header [Mega Menu Toggle]
function toggleClassOnAriaExpanded({
  toggleSelector,
  parentSelector,
  activeClass = 'is-expanded'
}) {
  const toggles = document.querySelectorAll(toggleSelector);
  if (!toggles.length) return;

  toggles.forEach((toggle) => {
    const parent = toggle.closest(parentSelector);
    if (!parent) return;

    const updateClass = () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      parent.classList.toggle(activeClass, isExpanded);
    };

    // Run once on load (in case menu is already open)
    updateClass();

    const observer = new MutationObserver(updateClass);

    observer.observe(toggle, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
  });
}


// Global [Device Type]
function conditionallyAddTouchClass() {
  // Check if device is touch screen or not
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  if (isTouchDevice) {
    document.body.classList.add('touch');
  } else {
    document.body.classList.add('no-touch');
  }
}


domReady(() => {
  toggleClassOnAriaExpanded({
    toggleSelector: '.wp-block-outermost-mega-menu__toggle',
    parentSelector: 'header.wp-block-template-part',
    activeClass: 'is-mega-menu-open',
  });

  conditionallyAddTouchClass();
});